const tracksValidationDE = {
    "trackName": {
        "required": "Der Titelname ist erforderlich",
        "length": "Der Titelname muss mehr als 1 und weniger als 255 Zeichen lang sein",
        "regexp": "Der Titelname darf nur aus Buchstaben, Zahlen, Leerzeichen und Unterstrichen bestehen"
    },
    "mix_name": {
        "required": "Bitte geben Sie den Mix-Namen ein",
        "regexp": "Der Mix-Name darf nur aus Buchstaben, Zahlen, Leerzeichen und Unterstrichen bestehen"
    },
    "artistName": {
        "required": "Bitte wählen Sie einen Künstler aus"
    },
    "artistType": {
        "required": "Bitte wählen Sie den Künstler-Typ aus"
    },
    "atleastOneMainArtist": {
        "required": "Mindestens ein Künstler muss Hauptkünstler sein"
    },
    "duplicateArtists": {
        "required": "Es gibt zwei oder mehr Künstler mit demselben Namen."
    },
    "publisherName": {
        "required": "Bitte wählen Sie einen Verlag aus"
    },
    "publisherAuthor": {
        "required": "Bitte geben Sie den echten Vor- und Nachnamen der Person ein."
    },
    "contributorName": {
        "required": "Bitte wählen Sie einen Mitwirkenden aus"
    },
    "contributorRole": {
        "required": "Bitte wählen Sie die Rolle des Mitwirkenden aus"
    },
    "atleastOneComposer": {
        "required": "Mindestens ein Mitwirkender sollte Komponist sein"
    },
    "atleastOneLyricist": {
        "required": "Mindestens ein Mitwirkender sollte Texter sein"
    },
    "copyright": {
        "required": "Urheberrecht ist erforderlich",
        "regexp": "Das Urheberrecht darf nur aus Buchstaben, Zahlen, Leerzeichen und Unterstrichen bestehen"
    },
    "copyrightYear": {
        "required": "Urheberrechtsjahr ist erforderlich",
        "regexp": "Das Urheberrechtsjahr muss ein gültiges Jahr sein"
    },
    "ISRC": {
        "required": "Bitte geben Sie ISRC an oder markieren Sie ISRC generieren",
        "regexp": "Bitte geben Sie einen gültigen ISRC-Code ein oder lassen Sie das Feld leer"
    },
    "DA_ISRC": {
        "required": "Bitte geben Sie Dolby Atmos ISRC an oder markieren Sie ISRC generieren",
        "regexp": "Bitte geben Sie einen gültigen ISRC-Code ein oder lassen Sie das Feld leer"
    },
    "trackLanguage": {
        "required": "Titel-Sprache ist erforderlich. Bitte wählen Sie die Sprache Ihres Titelnamens aus."
    },
    "trackVocals": {
        "required": "Titel-Gesang ist erforderlich. Bitte wählen Sie die Sprache Ihres Gesangs aus."
    },
    "trackGenre": {
        "required": "Bitte wählen Sie Ihr Titel-Genre aus."
    },
    "trackSubGenre": {
        "required": "Bitte wählen Sie Ihr Titel-Sub-Genre aus"
    },
    "featuringArtistMissing": {
        "required": "Der Titel muss den im Titel korrekt zugewiesenen Künstler mit der Rolle 'featuring' auflisten. Bitte ändern und erneut einreichen."
    }
};

export default tracksValidationDE;